import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { ExtractionSidebar } from './ExtractionSidebar';
import { ExtractionLeft } from './ExtractionLeft';
import { ExtractionRight } from './ExtractionRight';
import { ExtractionGateBanner, AutoExtractBanner } from './ExtractionGates';

export function ExtractionTab() {
  return (
    <div className="extraction-container">
      <ExtractionSidebar />
      <div className="extraction-main-wrapper">
        <ExtractionGateBanner />
        <AutoExtractBanner />
        <PanelGroup direction="horizontal" className="extraction-main">
          <Panel defaultSize={60} minSize={30}>
            <ExtractionLeft />
          </Panel>
          <PanelResizeHandle className="split-divider" />
          <Panel minSize={20}>
            <ExtractionRight />
          </Panel>
        </PanelGroup>
      </div>
    </div>
  );
}
